import { render } from "./AdminStageCreate.vue?vue&type=template&id=38530539&scoped=true&ts=true&lang=pug"
import script from "./AdminStageCreate.vue?vue&type=script&lang=ts&setup=true"
export * from "./AdminStageCreate.vue?vue&type=script&lang=ts&setup=true"

import "./AdminStageCreate.vue?vue&type=style&index=0&id=38530539&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38530539"]])

export default __exports__